export const subscriptionPaymentMethodComponent = {
  key: 'subscriptionPaymentMethodComponent',
  name: 'Subscription Payment Method Dept-Component',
  siteIdentifier: 'global',

  paymentErrorMessage: 'Please select a card with a valid expiration date',
  paymentMethodLabel: 'Payment Method',
  billingDateAlertLabel: 'This card will be charged {alertPrice} on your next billing date.'
};
